import Flickity from 'flickity-imagesloaded';
import { getBreakpoint } from './_utils';

const classes = {
	componentName: 'FeaturedRentals',
	noTruncated: 'FeaturedRentals-rentals--noTruncated',
};

const selectors = {
	baseComponent: `.${classes.componentName}`,
	container: `.${classes.componentName}-rentals`,
	carouselList: `.${classes.componentName}-rentalCarouselList`,
	card: `.${classes.componentName}-rentalCard`,
	ctaMore: `.${classes.componentName}-ctaMoreWrapper`,
	rentalCta: `.${classes.componentName}-rentalCta`,
	prevButton: `.${classes.componentName}-prevButton`,
	nextButton: `.${classes.componentName}-nextButton`,
};

const truncateConfig = {
	items: {
		small: 3,
		medium: 6,
		large: 9,
		xlarge: 12,
	},
	offsets: {
		small: 350,
		medium: 350,
		large: 350,
		xlarge: 360,
	},
	rows: 3,
};

let isExpanded = false;

const setUpTruncateList = ($component, $ctaMore) => {
	const $container = $component.find(selectors.container);

	if (!isExpanded) {
		truncate($container, $ctaMore);
	}
};

const truncate = ($container, $ctaMore) => {
	const $items = $container.find(selectors.card);
	const breakpoint = getBreakpoint();
	const numItems = truncateConfig.items[breakpoint];
	const shouldBeTruncated = $items.length > numItems;

	$container.css('height', 'auto');
	$items.each((_, item) => {
		const $cardCta = $(item).find(selectors.rentalCta);
		const $prevButton = $(item).find(selectors.prevButton);
		const $nextButton = $(item).find(selectors.nextButton);

		$cardCta.removeAttr('tabIndex');
		$prevButton.removeAttr('tabIndex');
		$nextButton.removeAttr('tabIndex');
		$(item).removeAttr('aria-hidden');
		$(item).show();
	});

	if (shouldBeTruncated) {
		let height = truncateConfig.offsets[breakpoint];
		const lastRowIndex = numItems - numItems / truncateConfig.rows;
		const $first = $items.eq(0);
		const $last = $items.eq(numItems - 1);
		const $rest = $items.slice(numItems);
		const $lastRowVisible = $items.slice(lastRowIndex, numItems);
		const $button = $ctaMore.find('button');

		// Remove previous click event handlers from button
		// so that it always has only one bounded
		$button.off('click.featuredRentals');

		$lastRowVisible.each((_, item) => {
			const $cardCta = $(item).find(selectors.rentalCta);
			const $prevButton = $(item).find(selectors.prevButton);
			const $nextButton = $(item).find(selectors.nextButton);

			$cardCta.attr('tabIndex', -1);
			$prevButton.attr('tabIndex', -1);
			$nextButton.attr('tabIndex', -1);
			$(item).attr('aria-hidden', true);
		});

		height += Math.floor(Math.abs($last.offset().top - $first.offset().top));
		$container.css('height', height);
		$rest.each((_, item) => $(item).hide());
		$ctaMore.show();
		$container.removeClass(classes.noTruncated);

		$button.on('click.featuredRentals', () => {
			const $firstOfLastRowVisible = $($lastRowVisible.get(0));

			$rest.each((_, item) => $(item).show());
			$ctaMore.hide();
			$container.addClass(classes.noTruncated);

			$lastRowVisible.each((_, item) => {
				const $cardCta = $(item).find(selectors.rentalCta);
				const $prevButton = $(item).find(selectors.prevButton);
				const $nextButton = $(item).find(selectors.nextButton);

				$cardCta.removeAttr('tabIndex');
				$prevButton.removeAttr('tabIndex');
				$nextButton.removeAttr('tabIndex');
				$(item).removeAttr('aria-hidden');
			});

			const lastItemPosition = $last.offset().top - 100;

			$('html, body')
				.clearQueue()
				.animate(
					{
						scrollTop: lastItemPosition,
					},
					500,
					() => {
						$firstOfLastRowVisible.find(selectors.rentalCta).focus();
						$rest.each((_, item) => {
							const carousel = $(item).find(selectors.carouselList).get(0);
							const flickity = Flickity.data(carousel);
							flickity && flickity.resize();
						});
					}
				);

			$container.css('height', 'auto');
			isExpanded = true;
		});
	} else {
		$ctaMore.hide();
		$container.addClass(classes.noTruncated);
	}
};

export default function init() {
	const $baseComponent = $(selectors.baseComponent);

	$baseComponent.each((_, component) => {
		const $component = $(component);
		const $ctaMore = $component.find(selectors.ctaMore);
		setUpTruncateList($component, $ctaMore);

		$(window).on('resize', () => {
			setUpTruncateList($component, $ctaMore);
		});
	});
}
